/**
 * The partner status ladder — one source of truth for the set, the order, and
 * the health band each status maps to. `classifyPartner` (`partnerMetrics.ts`)
 * assigns a status; the filter bar lists them; the table colours the chip by
 * band. None of those re-declare the list.
 */

/** Statuses in priority order — worst first. A partner gets the first it qualifies for. */
export const PARTNER_STATUSES = [
  "Contract Breach",
  "Needs Upgrade Now",
  "Upsell Ready",
  "Entitlement Review",
  "Under-adopted",
  "Healthy",
] as const;

export type PartnerStatus = (typeof PARTNER_STATUSES)[number];

/** Health band — the colour bucket a status falls into. */
export type HealthBand = "critical" | "watch" | "healthy";

export const BAND_BY_STATUS: Record<PartnerStatus, HealthBand> = {
  "Contract Breach": "critical",
  "Needs Upgrade Now": "critical",
  "Upsell Ready": "watch",
  "Entitlement Review": "watch",
  "Under-adopted": "healthy",
  Healthy: "healthy",
};

/**
 * Status = a band-coloured dot + the plain-text label (the POC legend's
 * treatment), shared by the table and the tile view. The label carries the
 * meaning and inherits the surrounding text color (~15:1), so it's readable
 * and not colour-alone; the dot is a graphical cue that only needs 3:1
 * non-text contrast, which `*.main` clears in both themes. No heavy pills.
 */
export const BAND_DOT: Record<HealthBand, string> = {
  critical: "error.main",
  watch: "info.main",
  healthy: "success.main",
};
